import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dod-message-banner',
  templateUrl: './dod-message-banner.component.html',
  styleUrls: ['./dod-message-banner.component.scss']
})
export class DodMessageBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
